import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelper } from './auth.jwt';

const TOKEN_NAME: string = 'enduserportal_authtoken';

@Injectable()
export class AuthService {
    #router = inject(Router);
    private savedUrl?: string;

    isAuth(): boolean {
        let token = this.getToken();
        return token != null && !JwtHelper.isTokenExpired(token);
    }

    getToken(): string {
        return localStorage.getItem(TOKEN_NAME) ?? '';
    }

    setToken(t: string) {
        localStorage.setItem(TOKEN_NAME, t);
    }

    clearToken() {
        localStorage.removeItem(TOKEN_NAME);
    }

    logout() {
        this.clearToken();
        this.#router.navigateByUrl('/login');
    }

    getIdentity(): any {
        return this.isAuth() ? JwtHelper.decodeToken(this.getToken()) : null;
    }

    getSavedUrl(): string | undefined {
        let url = this.savedUrl;
        delete this.savedUrl;
        return url;
    }

    saveTargetUrl(url: string) {
        this.savedUrl = url;
    }
}
